import React, { useState, useEffect } from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { getObjectFields } from "../../utils/mockDataGenerator";
import { Card } from "../ui/card";

interface ObjectFiltersProps {
  objectType: string;
  onFilterChange: (filters: Record<string, string>) => void;
  expanded?: boolean;
}

export function ObjectFilters({
  objectType,
  onFilterChange,
  expanded = false,
}: ObjectFiltersProps) {
  const [filters, setFilters] = useState<Record<string, string>>({});
  const fields = getObjectFields(objectType);

  // Reset filters when object type changes
  useEffect(() => {
    setFilters({});
  }, [objectType]);

  // Only show the first 5 fields unless expanded
  const displayFields = expanded ? fields : fields.slice(0, 5);

  const handleFilterChange = (field: string, value: string) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleClearFilters = () => {
    setFilters({});
    onFilterChange({});
  };

  return (
    <Card className="p-4 h-full overflow-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        {displayFields.map((field) => (
          <div key={field} className="space-y-2">
            <Label htmlFor={`filter-${field}`}>{field}</Label>
            <Input
              id={`filter-${field}`}
              value={filters[field] || ""}
              onChange={(e) => handleFilterChange(field, e.target.value)}
              placeholder={`Filter by ${field}...`}
            />
          </div>
        ))}
      </div>
      <div className="flex justify-end">
        <Button variant="outline" onClick={handleClearFilters}>
          Clear Filters
        </Button>
      </div>
    </Card>
  );
}
